import { SortOrder } from '../types';

export const sortOrderOptions: SortOrder[] = [
  SortOrder.storesAsc,
  SortOrder.storesDesc,
  SortOrder.numberAsc,
  SortOrder.numberDesc,
];
